export default class Popup {
    constructor(_root) {
        this._root = _root;

        if (this._root instanceof HTMLElement) {
            this._id = this._root.dataset.id;
            this._scope = this._root.dataset.scope;
            this._delay = parseInt(this._root.dataset.delay) ? parseInt(this._root.dataset.delay) : 1 ;
            this._closeBtn = this._root.querySelector("[data-close=popup]");
            this._btns = this._root.querySelectorAll(".popup-container a");

            this._initializePopup();
        }
    }

    _initializePopup() {
        if (window.localStorage.getItem('popup_' + this._id) !== "true") {
            setTimeout(() => {
                this._root.classList.remove("hidden");
            }, this._delay * 1000);
        }

        if (this._closeBtn instanceof HTMLElement) {
            this._closeBtn.addEventListener("click", () => {
                this._root.classList.add("hidden");
                this._storeDecisionForPopup(this._id);
                window.tracking.trackGTM({
                    'event': 'popup',
                    'action': 'closed'
                });
            })
        }

        if (this._btns instanceof NodeList) {
            this._btns.forEach(btn => {
                if (btn instanceof HTMLElement) {
                    btn.addEventListener("click", () => {
                        this._storeDecisionForPopup(this._id);
                    });
                }
            });
        }
    }

    _storeDecisionForPopup(id) {
        window.localStorage.setItem('popup_' + id, "true");
    }
}



// WEBPACK FOOTER //
// ./Private/Scripts/components/popup/Popup.js